<template>
  <span>
    <input
      :id="pitchtypesSectionId"
      v-model="showPitchesExpanded"
      class="show-checkbox"
      type="checkbox"
      aria-hidden="true"
      tabindex="-1"
    />
    <ul class="pt-list">
      <li
        v-for="(pitchtype, index) in (pitchtypes || []).slice(
          0,
          numberOfPitchtypesToShow,
        )"
        :key="`pt1-${index}-${pitchtype.id}`"
      >
        <div class="pitch-info">
          <div class="category-info">
            <pu-category-icons :categories="pitchtype.categories" />
            <div
              v-if="
                pitchtype.pitchesToSell <
                $config.public.pitchesToSellLowThreshold
              "
              class="status low-availability"
            >
              <img src="@/assets/images/timer.svg" />
              <translate :tt="{ pitchesToSell: pitchtype.pitchesToSell }">
                Only {pitchesToSell} left on our site
              </translate>
            </div>
          </div>
          <span class="pitch-name">{{ pitchtype.name }}</span>
        </div>
        <span
          v-if="pitchtype.price && pitchtype.pitchesToSell > 0"
          class="pitch-price"
        >
          <p class="price dated">
            <pu-price-losenge
              :price="pitchtype.price"
              data-test="campsite-pricing"
              class="pitch-price"
            />
            <translate class="pricing-period per-stay">per stay</translate>
          </p>
        </span>
      </li>
    </ul>

    <template v-if="pitchtypes && pitchtypes.length > numberOfPitchtypesToShow">
      <ul class="pt-list additional-pitchtypes">
        <li
          v-for="(pitchtype, index) in (pitchtypes || []).slice(
            numberOfPitchtypesToShow,
          )"
          :key="`pt2-${index}-${pitchtype.id}`"
        >
          <div class="pitch-info">
            <div class="category-info">
              <pu-category-icons :categories="pitchtype.categories" />
              <div
                v-if="
                  pitchtype.pitchesToSell <
                  $config.public.pitchesToSellLowThreshold
                "
                class="status low-availability"
              >
                <img src="@/assets/images/timer.svg" />
                <translate :tt="{ pitchesToSell: pitchtype.pitchesToSell }">
                  Only {pitchesToSell} left on our site
                </translate>
              </div>
            </div>
            <span class="pitch-name">{{ pitchtype.name }}</span>
          </div>
          <span
            v-if="pitchtype.price && pitchtype.pitchesToSell > 0"
            class="pitch-price"
          >
            <p class="price dated">
              <pu-price-losenge
                :price="pitchtype.price"
                data-test="campsite-pricing"
                class="pitch-price"
              />
              <translate class="pricing-period per-stay">per stay</translate>
            </p>
          </span>
        </li>
      </ul>
      <label
        :for="pitchtypesSectionId"
        :aria-label="$t('See more...')"
        class="show-more-pitches"
        @click.prevent="showMorePitches"
      >
        <span class="caret"
          ><span class="chevron-l" /><span class="chevron-r" /></span
        ><translate class="subsection-close-txt">Close</translate
        ><slot name="subsection-open-txt"
          ><translate
            class="subsection-open-txt"
            :data-sctrack="`${String($route.name)}--PuPricingResults-see-more`"
          >
            See more...
          </translate></slot
        >
      </label>
    </template>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PitchTypePricingResult } from '../../../../apps/search/types'

@Component
class PuPricingResults extends Vue {
  @Prop()
  pitchtypes: PitchTypePricingResult[]

  @Prop()
  searchResultIndex: number

  @Prop()
  numberOfPitchtypesToShow: number

  showPitchesExpanded = false

  get pitchtypesSectionId() {
    return `pitchtypes${this.searchResultIndex}`
  }

  showMorePitches() {
    this.showPitchesExpanded = !this.showPitchesExpanded
  }
}

export default toNative(PuPricingResults)
</script>

<style scoped>
@import url('@/assets/css/search-cards-pitchtypes.css');

.pitch-price {
  display: flex;
  margin-left: 0.3em;
  flex-direction: column;
  flex-shrink: 0;
  align-items: flex-end;
}

.price.dated {
  line-height: 1.1;
  text-align: right;
}

.price .pitch-price {
  color: var(--colour-header-light-blue);
}

.currency-symbol {
  font-weight: normal;
}

.status {
  color: var(--colour-offers);
  font-size: var(--small);
  margin: 0 0 0.3em 0;
  display: flex;
  line-height: 1.1;
}

.status img {
  width: auto;
  height: 1.1em;
  margin-right: 0.25em;
}
</style>
